/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Custom_Vocabulary_SubInputs */

const en_custom_vocabulary_sub = /** @type {(inputs: Custom_Vocabulary_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use KNP Guides for AI Transcription`)
};

const fr_custom_vocabulary_sub = /** @type {(inputs: Custom_Vocabulary_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisez les guides KNP pour la transcription IA`)
};

const de_custom_vocabulary_sub = /** @type {(inputs: Custom_Vocabulary_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutzen Sie KNP-Leitfäden für die KI-Transkription`)
};

const it_custom_vocabulary_sub = /** @type {(inputs: Custom_Vocabulary_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilizzare le guide KNP per la trascrizione AI`)
};

const ru_custom_vocabulary_sub = /** @type {(inputs: Custom_Vocabulary_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Используйте руководства KNP для транскрипции с помощью ИИ.`)
};

const es_custom_vocabulary_sub = /** @type {(inputs: Custom_Vocabulary_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilice las guías KNP para la transcripción de IA`)
};

const zh_cn2_custom_vocabulary_sub = /** @type {(inputs: Custom_Vocabulary_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用 KNP 指南进行 AI 转录`)
};

const ja_custom_vocabulary_sub = /** @type {(inputs: Custom_Vocabulary_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIトランスクリプションにKNPガイドを使用する`)
};

const hi_custom_vocabulary_sub = /** @type {(inputs: Custom_Vocabulary_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एआई ट्रांसक्रिप्शन के लिए केएनपी गाइड का उपयोग करें`)
};

const pt_pt2_custom_vocabulary_sub = /** @type {(inputs: Custom_Vocabulary_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use os Guias KNP para Transcrição por IA`)
};

/**
* | output |
* | --- |
* | "Use KNP Guides for AI Transcription" |
*
* @param {Custom_Vocabulary_SubInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const custom_vocabulary_sub = /** @type {((inputs?: Custom_Vocabulary_SubInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Custom_Vocabulary_SubInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_custom_vocabulary_sub(inputs)
	if (locale === "de") return de_custom_vocabulary_sub(inputs)
	if (locale === "it") return it_custom_vocabulary_sub(inputs)
	if (locale === "ru") return ru_custom_vocabulary_sub(inputs)
	if (locale === "es") return es_custom_vocabulary_sub(inputs)
	if (locale === "zh-CN") return zh_cn2_custom_vocabulary_sub(inputs)
	if (locale === "ja") return ja_custom_vocabulary_sub(inputs)
	if (locale === "hi") return hi_custom_vocabulary_sub(inputs)
	if (locale === "pt-PT") return pt_pt2_custom_vocabulary_sub(inputs)
	return en_custom_vocabulary_sub(inputs)
});